import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import '../../../containers/Pages/Edd/Edd.css';

const CancelSchedules = memo(props => {
  const {
    show,
    data,
    title,
    subtitle,
    setShowCancelSchedule,
    scheduleImportButtonText,
    handleScheduleCancel,
  } = props;
  const [deploymentChecked, setDeploymentChecked] = useState(false);
  const [importChecked, setImportChecked] = useState(false);

  return show ? (
    <div className="h-screen w-screen fixed top-0 left-0 backdrop-blur-sm  z-50 flex justify-center items-center transition-all duration-1000 ease-in-out">
      <div className="w-3/6  bg-white rounded-md z-50 shadow-2xl opacity-100 duration-1000 ease-in-out">
        <div className="flex justify-end">
          <button
            type="button"
            className="cursor-pointer transition-transform duration-700 hover:rotate-90 hover:text-primary text-dark-night"
            onClick={() => setShowCancelSchedule(false)}
          >
            <i className="material-icons text-[24px] m-4 !text-inherit">close</i>
          </button>
        </div>
        <h2 className=" mt-4 font-bold text-lg text-center">{title}</h2>
        <p className="text-sm mt-1 text[#ff8f00] supported-files text-center">{subtitle}</p>

        {data[0].importStatus !== 'scheduled_for_import' && data[0].deployStatus !== 'Scheduled' ? (
          <div className="flex justify-center pt-2 pb-2 font-bold text-red-500">
            <p>This file has not been scheduled for deploy or scheduled for import</p>
          </div>
        ) : (
          <>
            {data[0].importStatus === 'scheduled_for_import' && (
              <div className="flex justify-center mt-2 items-center space-x-2 ">
                <div className="checkbox-wrapper-46 ml-8">
                  <input
                    data-test="edd-filter-valid-status"
                    type="checkbox"
                    id="cbx-501"
                    className="inp-cbx"
                    checked={importChecked}
                    onChange={async () => {
                      setImportChecked(!importChecked);
                    }}
                  />
                  <label className="cbx" htmlFor="cbx-501">
                    <span>
                      <svg viewBox="0 0 12 10" height="10px" width="12px">
                        <polyline points="1.5 6 4.5 9 10.5 1" />
                      </svg>
                    </span>
                    {/* <span className="text-sm font-normal">Valid</span> */}
                  </label>
                </div>

                <div
                  type="button"
                  className=" text-gray-800  border focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 h-8 text-center me-2
                       flex items-center justify-center"
                >
                  <p className="font-bold text-inherit mr-4">
                    {`Scheduled Import date of ${data[0].scheduledImportDate}`}
                  </p>
                </div>
              </div>
            )}
            ({' '}
            {data[0].deployStatus === 'Scheduled' && (
              <div className="flex justify-center mt-2 items-center space-x-2 ">
                <div className="checkbox-wrapper-46 ml-8">
                  <input
                    data-test="edd-filter-valid-status"
                    type="checkbox"
                    id="cbx-502"
                    className="inp-cbx"
                    checked={deploymentChecked}
                    onChange={async () => {
                      setDeploymentChecked(!deploymentChecked);
                    }}
                  />
                  <label className="cbx" htmlFor="cbx-502">
                    <span>
                      <svg viewBox="0 0 12 10" height="10px" width="12px">
                        <polyline points="1.5 6 4.5 9 10.5 1" />
                      </svg>
                    </span>
                    {/* <span className="text-sm font-normal">Valid</span> */}
                  </label>
                </div>

                <div
                  type="button"
                  className=" text-gray-800  border focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 h-8 text-center me-2
                       flex items-center justify-center"
                >
                  <p className="font-bold text-inherit mr-4">
                    {`Scheduled Deployment date of ${data[0].scheduledDeploymentDateString}`}
                  </p>
                </div>
              </div>
            )}
            )
            <div className="flex justify-center pb-4  mt-8">
              <button
                type="button"
                className="bg-orange-500 active:bg-orange-300 hover:scale-x-105 hover:scale-y-105 transition duration-500 z-30 shadow-md  w-32 h-12 rounded-lg text-white text-sm font-bold px-2 hover:animate-pulseOpacity"
                onClick={async () => {
                  await handleScheduleCancel({
                    cancelScheduleDeployment: deploymentChecked,
                    cancelScheduleImport: importChecked,
                  });
                  setDeploymentChecked(false);
                  setImportChecked(false);
                }}
              >
                {scheduleImportButtonText}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  ) : null;
});

CancelSchedules.propTypes = {
  show: PropTypes.bool,
  data: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  setShowCancelSchedule: PropTypes.func,
  scheduleImportButtonText: PropTypes.string,
  handleScheduleCancel: PropTypes.func,
};

export default CancelSchedules;
